import FlexBlock from '@/components/ui/FlexBlock/FlexBlock';
import styles from './LearnMore.module.scss';
import React from 'react';
import { externalLinks } from '@/constants/externalLinks';
import ButtonLink from '@/components/ui/ButtonLink/ButtonLink.tsx';
import { trackEvent } from '@/utils/productAnalyticsUtil.ts';
import { productAnalyticsEvents } from '@/constants/productAnalyticsEvents.ts';

const LearnMore: React.FC = () => {
	return (
		<FlexBlock className={styles.learnMoreCard} flexDirection="column" justifyContent="space-between" flex={1}>
			<div className={styles.imageWrapper}></div>
			<div className={styles.text}>
				<h1>Travel with a lighter footprint</h1>
				<ButtonLink
					href={externalLinks.learnMoreAboutSustainableTravel}
					className={styles.learnMoreBtn}
					target="_blank"
					color="grey"
					onClick={() =>
						trackEvent(productAnalyticsEvents.myClimate.page.learnMore.help, {
							postHogEventName: 'learn_more_sustainable_travel_clicked',
							postHogProperties: { category: 'help' },
						})
					}
				>
					Learn more
				</ButtonLink>
			</div>
		</FlexBlock>
	);
};

export default LearnMore;
